import { useStagedJobsStore } from '@/stores/useStagedJobs';

export default defineNuxtRouteMiddleware(async (to) => {
  const stagedJobsStore = useStagedJobsStore();
  const totalElements = stagedJobsStore.pagination.totalElements;

  if (
    totalElements === 0 &&
    to.fullPath !== '/staged' &&
    to.fullPath !== '/manage-jobs'
  ) {
    await stagedJobsStore.getStagedJobs();
  }
});
